export default __webpack_public_path__ + "files/huc8_mo-a88f11efadd9229c1e2a87679962c31c.pbf";